/*
 *
 * App actions
 *
 */

import {
  GET_BILLING_INFO,
  GET_BILLING_INFO_ERROR,
  GET_BILLING_INFO_SUCCESS,
  GET_COMPANY_INFO,
  GET_COMPANY_INFO_ERROR,
  GET_COMPANY_INFO_SUCCESS,
  GET_INVOICE,
  GET_INVOICE_ERROR,
  GET_INVOICE_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_DATA,
  GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR,
  LOAD_SEARCH_FILTER_OPTIONS,
  LOAD_SEARCH_FILTER_OPTIONS_ERROR,
  LOAD_SEARCH_FILTER_OPTIONS_SUCCESS,
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  SHOW_SESSION_EXPIRATION_MODAL,
  REFRESH_USER_DATA,
  REFRESH_USER_DATA_SUCCESS,
  REFRESH_USER_DATA_ERROR,
  UPDATE_USER_DATA,
  SHOW_LINKEDIN_AUTHORIZE_MODAL,
  AUTHORIZE_LINKEDIN_INTEGRATION,
  LINKEDIN_INTEGRATION_ERROR,
  GET_LOGIN_TOKEN_LINKEDIN,
  REMOVE_LOGIN_TOKEN_LINKEDIN,
  PARTNERS_LOGIN,
  PARTNERS_LOGIN_ERROR,
  PARTNERS_LOGIN_SUCCESS,
  PARTNERS_FORGOT_PASSWORD,
  PARTNERS_FORGOT_PASSWORD_ERROR,
  PARTNERS_FORGOT_PASSWORD_SUCCESS,
  PARTNERS_SET_NEW_PASSWORD,
  PARTNERS_SET_NEW_PASSWORD_ERROR,
  PARTNERS_SET_NEW_PASSWORD_SUCCESS,
  REMOVE_FILTER,
  REMOVE_RESET_PASSWORD_FLAG,
  RESET_IDS,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR,
  UPDATE_PAID_THIS_SESSION,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_ERROR,
  RESET_PASSWORD_SUCCESS,
  RESET_REFRESH_PAGE,
  RESET_SCHEDULING_JOB_DETAIL_ID,
  RESET_SEARCH_FILTERS,
  SET_CURRENT_CANDIDATE_ID,
  SET_CURRENT_JOB_DETAIL_ID,
  SET_REFRESH_PAGE,
  SET_SCHEDULING_JOB_DETAIL_ID,
  SET_USER_INPUT,
  SET_ZR_JOB,
  UPDATE_SEARCH_FILTERS,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_SUCCESS,
  SET_NEW_PASSWORD_ERROR,
  GET_INVOICE_PRICING,
  GET_INVOICE_PRICING_SUCCESS,
  GET_INVOICE_PRICING_ERROR,
  SET_FROM_SEARCH_FLAG,
  SAVE_LAST_LOCATION,
  CLEAR_RESET_PASSWORD_ERRORS,
  UPDATE_COMPANY_DEFAULT_PIPELINE_ID,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  GET_SOURCES,
  GET_SOURCES_SUCCESS,
  GET_SOURCES_ERROR,
  CREATE_SOURCE,
  CREATE_SOURCE_SUCCESS,
  CREATE_SOURCE_ERROR,
  SHOW_NEW_JOB_MODAL,
  UPDATE_COMPANY_INFO,
  GET_IDENTITY_PROVIDER,
  GET_IDENTITY_PROVIDER_SUCCESS,
  GET_IDENTITY_PROVIDER_ERROR,
  SSO_LOGIN,
  SSO_LOGIN_SUCCESS,
  SSO_LOGIN_ERROR,
  RESET_ERROR_CODE,
  UPDATE_FIRST_TEAMS_LOGIN,
  UPDATE_FIRST_TEAMS_LOGIN_SUCCESS,
  UPDATE_FIRST_TEAMS_LOGIN_ERROR,
  SETUP_FEATURE_FLAGS,
  UPDATE_SOURCES_BY_LOCALE,
  SET_ORDER_IN_PROCESS,
  RESET_ORDER_IN_PROCESS,
  DELETE_CANDIDATE,
  DELETE_CANDIDATE_SUCCESS,
  DELETE_CANDIDATE_ERROR,
  RESET_DELETE_CANDIDATE_SUCCESS,
  UPDATE_VHS,
  SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
  RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
  FORCE_LOGOUT,
  CLEAR_FORCE_LOGOUT,
  SET_JOB_CREATION_INFO,
  GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES,
  GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR,
  GET_TEST_BATTERIES,
  GET_TEST_BATTERIES_SUCCESS,
  GET_TEST_BATTERIES_ERROR,
  SET_VI_MERCHANDISING_MODAL,
  SET_INTERVIEW_TEMPLATE_CREATION_INFO,
  RESET_INTERVIEW_TEMPLATE_CREATION_INFO,
  SEND_SUPPORT_BOT_QUESTION,
  SEND_SUPPORT_BOT_QUESTION_SUCCESS,
  SEND_SUPPORT_BOT_QUESTION_ERROR,
  SEND_RESPONSE_FEEDBACK,
  SEND_RESPONSE_FEEDBACK_SUCCESS,
  SEND_RESPONSE_FEEDBACK_ERROR,
  RESET_SUPPORT_BOT_RESPONSE,
  GET_CANDIDATE_ANALYTICS,
  GET_CANDIDATE_ANALYTICS_SUCCESS,
  GET_CANDIDATE_ANALYTICS_ERROR,
  GET_PREV_CANDIDATE_ANALYTICS,
  GET_PREV_CANDIDATE_ANALYTICS_SUCCESS,
  GET_PREV_CANDIDATE_ANALYTICS_ERROR,
  GET_ASSESSMENT_ANALYTICS,
  GET_ASSESSMENT_ANALYTICS_SUCCESS,
  GET_ASSESSMENT_ANALYTICS_ERROR,
  GET_PREV_ASSESSMENT_ANALYTICS,
  GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS,
  GET_PREV_ASSESSMENT_ANALYTICS_ERROR,
  GET_STRUCTURED_INTERVIEW_ANALYTICS,
  GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS,
  GET_STRUCTURED_INTERVIEW_ANALYTICS_ERROR,
  GET_SCORE_RANGE_ANALYTICS,
  GET_SCORE_RANGE_ANALYTICS_SUCCESS,
  GET_SCORE_RANGE_ANALYTICS_ERROR,
  GET_BUSINESS_VALUE,
  GET_BUSINESS_VALUE_SUCCESS,
  GET_BUSINESS_VALUE_ERROR,
  SET_ANALYTICS_REQUESTED,
  CLEAR_CUSTOM_DATE_ANALYTICS,
  TRACK_POSTHIRE_LOGIN,
  TRACK_POSTHIRE_LOGIN_SUCCESS,
  TRACK_POSTHIRE_LOGIN_ERROR,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_ERROR,
  RESEND_VERIFICATION_EMAIL,
  RESEND_VERIFICATION_EMAIL_SUCCESS,
  RESEND_VERIFICATION_EMAIL_ERROR,
  CHECK_VALID_VERIFY_TOKEN,
  CHECK_VALID_VERIFY_TOKEN_SUCCESS,
  CHECK_VALID_VERIFY_TOKEN_ERROR,
} from "./constants";

/* ----------- Set User Input ----------- */

export function setUserInput(field, value) {
  return {
    type: SET_USER_INPUT,
    field,
    value,
  };
}

/* --------- Set/Reset Current Job Detail Id and current Candidate Id ---------- */

export function setCurrentJobDetailId(jobDetailId, stage) {
  return {
    type: SET_CURRENT_JOB_DETAIL_ID,
    jobDetailId,
    stage,
  };
}
export function setCurrentCandidateId(candidateId) {
  return {
    type: SET_CURRENT_CANDIDATE_ID,
    candidateId,
  };
}

export function resetCandidateAndJobDetailIds() {
  return {
    type: RESET_IDS,
  };
}

/* --------- Set and Reset Refresh Page ---------- */

export function setRefreshPage(location) {
  return {
    type: SET_REFRESH_PAGE,
    location,
  };
}

export function resetRefreshPage() {
  return {
    type: RESET_REFRESH_PAGE,
  };
}

/* ----------- Search Filters ----------- */

export function loadSearchFilterOptions() {
  return {
    type: LOAD_SEARCH_FILTER_OPTIONS,
  };
}
export function loadSearchFilterOptionsSuccess(options) {
  return {
    type: LOAD_SEARCH_FILTER_OPTIONS_SUCCESS,
    options,
  };
}
export function loadSearchFilterOptionsError() {
  return {
    type: LOAD_SEARCH_FILTER_OPTIONS_ERROR,
  };
}
export function updateSearchFilters(formData) {
  return {
    type: UPDATE_SEARCH_FILTERS,
    formData,
  };
}
export function removeFilter(filterName) {
  return {
    type: REMOVE_FILTER,
    filterName,
  };
}
export function resetSearchFilters() {
  return {
    type: RESET_SEARCH_FILTERS,
  };
}

export function setSchedulingJobDetailId(jobDetailId) {
  return {
    type: SET_SCHEDULING_JOB_DETAIL_ID,
    jobDetailId,
  };
}

export function resetSchedulingJobDetailId() {
  return {
    type: RESET_SCHEDULING_JOB_DETAIL_ID,
  };
}

/* ----------- Login ---------- */

export function login(
  formData,
  liOnboarding = false,
  liOnboardingIntegrationData = null
) {
  return {
    type: LOGIN,
    formData,
    liOnboarding,
    liOnboardingIntegrationData,
  };
}
export function loginSuccess(token, userData, configCatObject) {
  return {
    type: LOGIN_SUCCESS,
    token,
    userData,
    configCatObject,
  };
}
export function loginError(errorCode) {
  return {
    type: LOGIN_ERROR,
    errorCode,
  };
}
export function showSessionExpirationModal() {
  return {
    type: SHOW_SESSION_EXPIRATION_MODAL,
  };
}

export function refreshUserData() {
  return {
    type: REFRESH_USER_DATA,
  };
}
export function refreshUserDataSuccess(userData) {
  return {
    type: REFRESH_USER_DATA_SUCCESS,
    userData,
  };
}
export function refreshUserDataError(error) {
  return {
    type: REFRESH_USER_DATA_ERROR,
    error,
  };
}

export function updateUserData(userData) {
  return {
    type: UPDATE_USER_DATA,
    userData,
  };
}

/* ----------- LinkedIn Integration ---------- */
export function showLinkedInAuthorizeModal(token, userEmail) {
  return {
    type: SHOW_LINKEDIN_AUTHORIZE_MODAL,
    token,
    userEmail,
  };
}
export function authorizeLinkedInIntegration(
  token,
  userEmail,
  liOnboardingIntegrationData
) {
  return {
    type: AUTHORIZE_LINKEDIN_INTEGRATION,
    token,
    userEmail,
    liOnboardingIntegrationData,
  };
}
export function linkedInIntegrationError(userEmail, error) {
  return {
    type: LINKEDIN_INTEGRATION_ERROR,
    userEmail,
    error,
  };
}
export function getLoginTokenLinkedIn(token) {
  return {
    type: GET_LOGIN_TOKEN_LINKEDIN,
    token,
  };
}
export function removeLoginTokenLinkedIn() {
  return {
    type: REMOVE_LOGIN_TOKEN_LINKEDIN,
  };
}

/* ----------- Partners Login ---------- */

export function partnersLogin(formData) {
  return {
    type: PARTNERS_LOGIN,
    formData,
  };
}
export function partnersLoginSuccess(token, userData) {
  return {
    type: PARTNERS_LOGIN_SUCCESS,
    token,
    userData,
  };
}
export function partnersLoginError(errorCode) {
  return {
    type: PARTNERS_LOGIN_ERROR,
    errorCode,
  };
}

/* ------------ Partners Forgot Password ----------- */

export function partnersForgotPassword(emailAddress) {
  return {
    type: PARTNERS_FORGOT_PASSWORD,
    emailAddress,
  };
}
export function partnersForgotPasswordSuccess() {
  return {
    type: PARTNERS_FORGOT_PASSWORD_SUCCESS,
  };
}
export function partnersForgotPasswordError(err) {
  return {
    type: PARTNERS_FORGOT_PASSWORD_ERROR,
    err,
  };
}

/* ---------- Partners Set New Password ---------- */

export function setNewPasswordPartners(tk1, tk2, password) {
  return {
    type: PARTNERS_SET_NEW_PASSWORD,
    tk1,
    tk2,
    password,
  };
}
export function setNewPasswordPartnersSuccess() {
  return {
    type: PARTNERS_SET_NEW_PASSWORD_SUCCESS,
  };
}
export function setNewPasswordPartnersError(err) {
  return {
    type: PARTNERS_SET_NEW_PASSWORD_ERROR,
    err,
  };
}

/* ------------ Reset Password ----------- */

export function resetPassword(emailAddress, action) {
  return {
    type: RESET_PASSWORD,
    emailAddress,
    action,
  };
}
export function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS,
  };
}
export function resetPasswordError(err) {
  return {
    type: RESET_PASSWORD_ERROR,
    err,
  };
}

/* ----------- Clear Reset Password Errors ---------- */

export function clearResetEmailErrors() {
  return {
    type: CLEAR_RESET_PASSWORD_ERRORS,
  };
}

/* ----------- Update Paid This Session ----------- */

export function updatePaidThisSession() {
  return {
    type: UPDATE_PAID_THIS_SESSION,
  };
}

/* ------------ Get Invoice ----------- */

export function getInvoice(invoiceNumber) {
  return {
    type: GET_INVOICE,
    invoiceNumber,
  };
}
export function getInvoiceSuccess() {
  return {
    type: GET_INVOICE_SUCCESS,
  };
}
export function getInvoiceError(err) {
  return {
    type: GET_INVOICE_ERROR,
    err,
  };
}

/* ------------ Get Company Info ----------- */
export function getCompanyInfo(redirect = null) {
  return {
    type: GET_COMPANY_INFO,
    redirect,
  };
}
export function getCompanyInfoSuccess(companyInfo) {
  return {
    type: GET_COMPANY_INFO_SUCCESS,
    companyInfo,
  };
}
export function getCompanyInfoError(err) {
  return {
    type: GET_COMPANY_INFO_ERROR,
    err,
  };
}

/* ----------- Get Roles ---------- */

export function getRoles() {
  return {
    type: GET_ROLES,
  };
}
export function getRolesSuccess(rolesResponse) {
  return {
    type: GET_ROLES_SUCCESS,
    roles: rolesResponse,
  };
}
export function getRolesError(error) {
  return {
    type: GET_ROLES_ERROR,
    error,
  };
}

/* ---------- Remove Password Reset Flag ------------ */

export function removeResetPasswordFlag() {
  return {
    type: REMOVE_RESET_PASSWORD_FLAG,
  };
}

/* ---------- Set ZR Job ----------- */

export function setZipRecruiterJob(jobDetailId, zrLink) {
  return {
    type: SET_ZR_JOB,
    jobDetailId,
    zrLink,
  };
}

/* ---------- Get Billing Info ---------- */

export function getBillingInfo(userAccountId) {
  return {
    type: GET_BILLING_INFO,
    userAccountId,
  };
}
export function getBillingInfoSuccess(billingInfo) {
  return {
    type: GET_BILLING_INFO_SUCCESS,
    billingInfo,
  };
}
export function getBillingInfoError(err) {
  return {
    type: GET_BILLING_INFO_ERROR,
    err,
  };
}

/* ---------- Get Invoice Pricing ---------- */

export function getInvoicePricing(invoiceNumber) {
  return {
    type: GET_INVOICE_PRICING,
    invoiceNumber,
  };
}
export function getInvoicePricingSuccess(invoicePricing) {
  return {
    type: GET_INVOICE_PRICING_SUCCESS,
    invoicePricing,
  };
}
export function getInvoicePricingError(err) {
  return {
    type: GET_INVOICE_PRICING_ERROR,
    err,
  };
}

/* ---------- Set New Password ---------- */

export function setNewPassword(tk1, tk2, password) {
  return {
    type: SET_NEW_PASSWORD,
    tk1,
    tk2,
    password,
  };
}
export function setNewPasswordSuccess() {
  return {
    type: SET_NEW_PASSWORD_SUCCESS,
  };
}
export function setNewPasswordError(err) {
  return {
    type: SET_NEW_PASSWORD_ERROR,
    err,
  };
}

/* ----------- Set fromSearch Flag ---------- */

export function setFromSearchFlag() {
  return {
    type: SET_FROM_SEARCH_FLAG,
  };
}

/* ----------- save apps last location ---------- */

export function saveLastLocation(pathname) {
  return {
    type: SAVE_LAST_LOCATION,
    pathname,
  };
}

export function updateCompanyDefaultPipeline(pipelineId, pipelineStageMapId) {
  return {
    type: UPDATE_COMPANY_DEFAULT_PIPELINE_ID,
    pipelineId,
    pipelineStageMapId,
  };
}

/* ---------_ get users ---------- */

export function getUsers() {
  return {
    type: GET_USERS,
  };
}
export function getUsersSuccess(activeUsers, inactiveUsers) {
  return {
    type: GET_USERS_SUCCESS,
    activeUsers,
    inactiveUsers,
  };
}
export function getUsersError(error) {
  return {
    type: GET_USERS_ERROR,
    error,
  };
}

/* ---------- Get Sources ---------- */

export function getSources() {
  return {
    type: GET_SOURCES,
  };
}
export function getSourcesSuccess(sources) {
  return {
    type: GET_SOURCES_SUCCESS,
    sources,
  };
}
export function getSourcesError(err) {
  return {
    type: GET_SOURCES_ERROR,
    err,
  };
}

/* ---------- create source ---------- */

export function createSource(jobId, sourceName) {
  return {
    type: CREATE_SOURCE,
    jobId,
    sourceName,
  };
}
export function createSourceSuccess(source) {
  return {
    type: CREATE_SOURCE_SUCCESS,
    source,
  };
}
export function createSourceError(err) {
  return {
    type: CREATE_SOURCE_ERROR,
    err,
  };
}

/* ---------- Show New Job Modal ----------- */

export function updateShowNewJobModal(value) {
  return {
    type: SHOW_NEW_JOB_MODAL,
    value,
  };
}

/* ----------- Update Company Info ---------- */

export function updateCompanyInfo(field, value) {
  return {
    type: UPDATE_COMPANY_INFO,
    field,
    value,
  };
}

/* ---------- Get identity provider ---------- */

export function getIdentityProvider(
  emailAddress,
  companyAccountId
  // rememberMe
) {
  return {
    type: GET_IDENTITY_PROVIDER,
    formData: {
      emailAddress,
      companyAccountId,
    },
    // rememberMe
  };
}
export function getIdentityProviderSuccess(identityProviderData) {
  return {
    type: GET_IDENTITY_PROVIDER_SUCCESS,
    identityProviderData,
  };
}
export function getIdentityProviderError(err) {
  return {
    type: GET_IDENTITY_PROVIDER_ERROR,
    err,
  };
}

/* ---------- Sso login ---------- */

export function ssoLogin(
  authorizationCode,
  codeVerifier,
  rememberMe,
  isPostHireLogin = false
) {
  return {
    type: SSO_LOGIN,
    formData: {
      authorizationCode,
      codeVerifier,
      rememberMe,
    },
    isPostHireLogin,
  };
}
export function ssoLoginSuccess(userData, configCatObject) {
  return {
    type: SSO_LOGIN_SUCCESS,
    userData,
    configCatObject,
  };
}
export function ssoLoginError(error) {
  return {
    type: SSO_LOGIN_ERROR,
    error,
  };
}

/* ---------- Update Sources ---------- */

export function updateSourcesByLocale() {
  return {
    type: UPDATE_SOURCES_BY_LOCALE,
  };
}

export function resetErrorCode() {
  return { type: RESET_ERROR_CODE };
}

/* ----------- Setup Feature Flags -----------*/

export function setupFeatureFlag(configCatObject) {
  return {
    type: SETUP_FEATURE_FLAGS,
    configCatObject,
  };
}

/* ---------- Update Teams Login ---------- */
export function updateFirstTeamsLogin() {
  return {
    type: UPDATE_FIRST_TEAMS_LOGIN,
  };
}
export function updateFirstTeamsLoginSuccess() {
  return {
    type: UPDATE_FIRST_TEAMS_LOGIN_SUCCESS,
  };
}
export function updateFirstTeamsLoginError() {
  return {
    type: UPDATE_FIRST_TEAMS_LOGIN_ERROR,
  };
}

/* ----------- Update Order in Process ----------- */

export function setOrderInProcess() {
  return {
    type: SET_ORDER_IN_PROCESS,
  };
}

export function resetOrderInProcess() {
  return {
    type: RESET_ORDER_IN_PROCESS,
  };
}

/* ----------- Delete Candidate ----------- */
// if delete from Results, we need jobId and currentStageId to update the candidates and candidate counts

export function deleteCandidate(
  jobId,
  currentStageId,
  currentCandidateId,
  deleteLocation
) {
  return {
    type: DELETE_CANDIDATE,
    jobId,
    currentStageId,
    currentCandidateId,
    deleteLocation,
  };
}

export function deleteCandidateSuccess(currentCandidateId) {
  return {
    type: DELETE_CANDIDATE_SUCCESS,
    currentCandidateId,
  };
}

export function deleteCandidateError(error) {
  return {
    type: DELETE_CANDIDATE_ERROR,
    error,
  };
}

/* ----------- Reset Delete Candidate Success ----------- */

export function resetDeleteCandidateSuccess() {
  return {
    type: RESET_DELETE_CANDIDATE_SUCCESS,
  };
}

/* ---------- Update VHS ----------- */

export function updateVhs(vhs) {
  return {
    type: UPDATE_VHS,
    vhs,
  };
}

/* --------- Set Current VideoInterview Template Id  ---------- */

export function setCurrentVideoInterviewTemplateId(templateId) {
  return {
    type: SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
    templateId,
  };
}

/* --------- Set Current VideoInterview Template Id  ---------- */

export function resetCurrentVideoInterviewTemplateId() {
  return {
    type: RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
  };
}

/* --------- Get Dynamic Score Reports Data  ---------- */

export function getDynamicScoreReportsData(
  testEventId,
  source,
  userAccountId,
  testId,
  format,
  reportType,
  testName,
  second
) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA,
    testEventId,
    source,
    userAccountId,
    testId,
    format,
    reportType,
    testName,
    second,
  };
}
export function getDynamicScoreReportsDataSuccess(
  dynamicScoreReportsData,
  testEventId,
  source,
  userAccountId
) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS,
    dynamicScoreReportsData,
    testEventId,
    source,
    userAccountId,
  };
}
export function getDynamicScoreReportsDataError(errorMsg) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR,
    errorMsg,
  };
}

/* --------- Get Work Styles for Dynamic Score Reports  ---------- */

export function getDynamicScoreReportsWorkStyles(testEventId, format) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES,
    testEventId,
    format,
  };
}
export function getDynamicScoreReportsWorkStylesSuccess(
  dynamicScoreReportsWorkStylesData
) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS,
    dynamicScoreReportsWorkStylesData,
  };
}
export function getDynamicScoreReportsWorkStylesError(error) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR,
    error,
  };
}

/* ----------- Reset Delete Candidate Success ----------- */

export function setLogutFlag() {
  return {
    type: FORCE_LOGOUT,
  };
}

export function clearLogoutFlag() {
  return {
    type: CLEAR_FORCE_LOGOUT,
  };
}

/* ----------- Set Job Creation Info ----------- */

export function setJobCreationInfo(jobCreationInfo) {
  return {
    type: SET_JOB_CREATION_INFO,
    jobCreationInfo,
  };
}

// --------- get test batteries ---------

export function getTestBatteries() {
  return {
    type: GET_TEST_BATTERIES,
  };
}
export function getTestBatteriesSuccess(testBatteries) {
  return {
    type: GET_TEST_BATTERIES_SUCCESS,
    testBatteries,
  };
}
export function getTestBatteriesError(error) {
  return {
    type: GET_TEST_BATTERIES_ERROR,
    data: error,
  };
}

// --------- set show VI merchandising modal ---------
export function setShowVIMerchandisingModal(value) {
  return {
    type: SET_VI_MERCHANDISING_MODAL,
    value,
  };
}

/* ----------- Set Interview Template Creation Info ----------- */

export function setInterviewTemplateCreationInfo(
  interviewTemplateCreationInfo
) {
  return {
    type: SET_INTERVIEW_TEMPLATE_CREATION_INFO,
    interviewTemplateCreationInfo,
  };
}

/* ----------- Reset Interview Template Creation Info ----------- */

export function resetInterviewTemplateCreationInfo() {
  return {
    type: RESET_INTERVIEW_TEMPLATE_CREATION_INFO,
  };
}

/* ---------- Send Support Bot Question ---------- */

export function sendSupportBotQuestion(formData) {
  return {
    type: SEND_SUPPORT_BOT_QUESTION,
    formData,
  };
}

export function sendSupportBotQuestionSuccess(response) {
  return {
    type: SEND_SUPPORT_BOT_QUESTION_SUCCESS,
    response,
  };
}

export function sendSupportBotQuestionError(err) {
  return {
    type: SEND_SUPPORT_BOT_QUESTION_ERROR,
    err,
  };
}

/* ---------- Send Support Bot Response Feedback ---------- */

export function sendResponseFeedback(formData) {
  return {
    type: SEND_RESPONSE_FEEDBACK,
    formData,
  };
}

export function sendResponseFeedbackSuccess() {
  return {
    type: SEND_RESPONSE_FEEDBACK_SUCCESS,
  };
}

export function sendResponseFeedbackError(err) {
  return {
    type: SEND_RESPONSE_FEEDBACK_ERROR,
    err,
  };
}

/* ---------- Reset Support Bot Response ---------- */

export function resetSupportBotResponse() {
  return {
    type: RESET_SUPPORT_BOT_RESPONSE,
  };
}

/* ---------- Get current candidate analytics ---------- */

export function getCandidateAnalytics(dateFilter, startDate, endDate) {
  return {
    type: GET_CANDIDATE_ANALYTICS,
    dateFilter,
    startDate,
    endDate,
  };
}
export function getCandidateAnalyticsSuccess(data, dateFilter, dataType) {
  return {
    type: GET_CANDIDATE_ANALYTICS_SUCCESS,
    data,
    dateFilter,
    dataType,
  };
}
export function getCandidateAnalyticsError(err) {
  return {
    type: GET_CANDIDATE_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get previous candidate analytics ---------- */

export function getPrevCandidateAnalytics(dateFilter) {
  return {
    type: GET_PREV_CANDIDATE_ANALYTICS,
    dateFilter,
  };
}
export function getPrevCandidateAnalyticsSuccess(data, dateFilter, dataType) {
  return {
    type: GET_PREV_CANDIDATE_ANALYTICS_SUCCESS,
    data,
    dateFilter,
    dataType,
  };
}
export function getPrevCandidateAnalyticsError(err) {
  return {
    type: GET_PREV_CANDIDATE_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get current assessment analytics ---------- */

export function getAssessmentAnalytics(dateFilter, startDate, endDate) {
  return {
    type: GET_ASSESSMENT_ANALYTICS,
    dateFilter,
    startDate,
    endDate,
  };
}
export function getAssessmentAnalyticsSuccess(data, dateFilter, dataType) {
  return {
    type: GET_ASSESSMENT_ANALYTICS_SUCCESS,
    data,
    dateFilter,
    dataType,
  };
}
export function getAssessmentAnalyticsError(err) {
  return {
    type: GET_ASSESSMENT_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get previous assessment analytics ---------- */

export function getPrevAssessmentAnalytics(dateFilter) {
  return {
    type: GET_PREV_ASSESSMENT_ANALYTICS,
    dateFilter,
  };
}
export function getPrevAssessmentAnalyticsSuccess(data, dateFilter, dataType) {
  return {
    type: GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS,
    data,
    dateFilter,
    dataType,
  };
}
export function getPrevAssessmentAnalyticsError(err) {
  return {
    type: GET_PREV_ASSESSMENT_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get structured interview analytics ---------- */

export function getStructuredInterviewAnalytics(
  dateFilter,
  startDate,
  endDate
) {
  return {
    type: GET_STRUCTURED_INTERVIEW_ANALYTICS,
    dateFilter,
    startDate,
    endDate,
  };
}
export function getStructuredInterviewAnalyticsSuccess(data, dateFilter) {
  return {
    type: GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS,
    data,
    dateFilter,
  };
}
export function getStructuredInterviewAnalyticsError(err) {
  return {
    type: GET_STRUCTURED_INTERVIEW_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get score range analytics ---------- */

export function getScoreRangeAnalytics(dateFilter, startDate, endDate) {
  return {
    type: GET_SCORE_RANGE_ANALYTICS,
    dateFilter,
    startDate,
    endDate,
  };
}
export function getScoreRangeAnalyticsSuccess(data, dateFilter) {
  return {
    type: GET_SCORE_RANGE_ANALYTICS_SUCCESS,
    data,
    dateFilter,
  };
}
export function getScoreRangeAnalyticsError(err) {
  return {
    type: GET_SCORE_RANGE_ANALYTICS_ERROR,
    err,
  };
}

/* ---------- Get business value ---------- */

export function getBusinessValue(dateFilter) {
  return {
    type: GET_BUSINESS_VALUE,
    dateFilter,
  };
}
export function getBusinessValueSuccess(data, dateFilter) {
  return {
    type: GET_BUSINESS_VALUE_SUCCESS,
    data,
    dateFilter,
  };
}
export function getBusinessValueError(err) {
  return {
    type: GET_BUSINESS_VALUE_ERROR,
    err,
  };
}

/* ---------- Set analytics requested ---------- */

export function setAnalyticsRequested(dateFilter) {
  return {
    type: SET_ANALYTICS_REQUESTED,
    dateFilter,
  };
}

/* ----------- Clear custom date analytics ----------- */

export function clearCustomDateAnalytics() {
  return {
    type: CLEAR_CUSTOM_DATE_ANALYTICS,
  };
}

/* ---------- Track posthire login ---------- */

export function trackPosthireLogin() {
  return {
    type: TRACK_POSTHIRE_LOGIN,
  };
}
export function trackPosthireLoginSuccess() {
  return {
    type: TRACK_POSTHIRE_LOGIN_SUCCESS,
  };
}
export function trackPosthireLoginError(err) {
  return {
    type: TRACK_POSTHIRE_LOGIN_ERROR,
    err,
  };
}

/* ---------- Set Password ---------- */

export function setPassword(verifyToken, password) {
  return {
    type: SET_PASSWORD,
    verifyToken,
    password,
  };
}
export function setPasswordSuccess() {
  return {
    type: SET_PASSWORD_SUCCESS,
  };
}
export function setPasswordError(err) {
  return {
    type: SET_PASSWORD_ERROR,
    err,
  };
}

/* ---------- Resend Verification Email ---------- */

export function resendVerificationEmail(emailAddress) {
  return {
    type: RESEND_VERIFICATION_EMAIL,
    emailAddress,
  };
}
export function resendVerificationEmailSuccess() {
  return {
    type: RESEND_VERIFICATION_EMAIL_SUCCESS,
  };
}
export function resendVerificationEmailError(err) {
  return {
    type: RESEND_VERIFICATION_EMAIL_ERROR,
    err,
  };
}

/* ---------- Check Valid Verify Token ---------- */

export function checkValidVerifyToken(verifyToken) {
  return {
    type: CHECK_VALID_VERIFY_TOKEN,
    verifyToken,
  };
}
export function checkValidVerifyTokenSuccess(data) {
  return {
    type: CHECK_VALID_VERIFY_TOKEN_SUCCESS,
    data,
  };
}
export function checkValidVerifyTokenError(errorData) {
  return {
    type: CHECK_VALID_VERIFY_TOKEN_ERROR,
    errorData,
  };
}
